import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import RequestActions from "../RequestListComponent/RequestActions";

import "../../styles/autoLombardLayout.scss";

const EditRequestComponent = ({ setTitlePage }) => {

  const { accessFeatures, isLoadingConfiguration } = useSelector(
    ({ user }) => user
  );

  useEffect(() => {
    accessFeatures["title.header_section"] && setTitlePage("Изменение заявок");
  }, [isLoadingConfiguration]);

  return (
    <>
      <RequestActions />
      <div>Изменение заявок. В разработке</div>
    </>
  );
};

export default EditRequestComponent;
